/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

const ButtonSet = /*#__PURE__*/React__default.forwardRef(function ButtonSet(_ref, ref) {
  let {
    children,
    className,
    stacked,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const buttonSetClasses = cx(className, `${prefix}--btn-set`, {
    [`${prefix}--btn-set--stacked`]: stacked
  });
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    className: buttonSetClasses,
    ref: ref
  }), children);
});
ButtonSet.displayName = 'ButtonSet';
ButtonSet.propTypes = {
  /**
   * Specify the content of your ButtonSet
   */
  children: PropTypes.node,
  /**
   * Specify an optional className to be added to your ButtonSet
   */
  className: PropTypes.string,
  /**
   * Specify the button arrangement of the set (vertically stacked or
   * horizontal)
   */
  stacked: PropTypes.bool
};

export { ButtonSet as default };
